import h from './helpers.js'

const help = () => {
	
	// Open article that's linked to
	let match = window.location.hash.match(/^#help\/(.+)/)
	if (match) Beacon('article', match[1])
	
	// Open chat
	h.on('click', '[href="#chat"]', e => {
		e.preventDefault()
		Beacon('open')
		Beacon('navigate', '/ask/')
	})
	
	// Ask question
	h.on('click', '[href="#ask"]', e => {
		e.preventDefault()
		Beacon('open')
		Beacon('navigate', '/ask/')
	})
	
	// FAQs
	h.on('click', '[href="#faq"]', e => {
		e.preventDefault()
		Beacon('open')
		Beacon('navigate', '/answers/')
	})
	
	h.on('click', '[data-beacon-article]', e => {
		e.preventDefault()
		const article = e.target.dataset['beacon-article']
		Beacon('open')
		Beacon('article', article)
	})
		
}

export default help
